import { render, staticRenderFns } from "./jlkTableColumn.vue?vue&type=template&id=4fe7412f&scoped=true"
import script from "./jlkTableColumn.vue?vue&type=script&lang=js"
export * from "./jlkTableColumn.vue?vue&type=script&lang=js"
import style0 from "./jlkTableColumn.vue?vue&type=style&index=0&id=4fe7412f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe7412f",
  null
  
)

export default component.exports